import { jsx as o } from "react/jsx-runtime";
import { SvgIcon as L } from "../SvgIcon.js";
const d = (e) => /* @__PURE__ */ o(L, { ...e, children: /* @__PURE__ */ o(
  "path",
  {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM12.3535 6.33163L14.475 10.0001H16.254V11.2598H13.7568L11.6352 7.58025L7.52473 14.6963L6.79545 13.4476L5.53578 11.2598H3.75677V10.0001H6.25401L7.52473 12.199L11.6352 5.08301L12.3535 6.33163Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }
) });
export {
  d as Activity
};
//# sourceMappingURL=Activity.js.map
